import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FileUploaderInterface } from './file-uploader.interface';

import { FileControlValueAccessor } from './file-control-value-accessor';
import { FileUploadInfo } from './file-upload-info';

const STRING_CONTROL_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FileGroupUploaderComponent),
  multi: true,
};

@Component({
  selector: 'forms-file-group-uploader',
  styleUrls: ['./file-group-uploader.component.scss'],
  template: `
    <div class="preview" *ngFor="let file of value; let i = index">
      <forms-file-upload-field
        [label]="label"
        [isUploaded]="true"
        [fileName]="file.name"
        [fileUrl]="file.url"
        (removeFile)="clearValue($event)"
        [index]="i"
        [fileTypes]="fileTypes"
        [disabled]="disabled"
        [enableDownload]="enableDownload"
      ></forms-file-upload-field>
    </div>
    <div *ngIf="value.length > 0" class="add-spacing"></div>
    <ng-container *ngIf="canUpload">
      <forms-file-upload-field
        [label]="label"
        [uploadUrl]="uploadUrl"
        [customUploader]="customUploader"
        [formController]="formGroup.controls[this.formControlName]"
        [fileTypes]="fileTypes"
        [disabled]="disabled"
        (fileUploaded)="onFileUploaded($event)"
        (fileUploadError)="handleError($event)"
      ></forms-file-upload-field>
      <div class="hint-description" *ngIf="description">{{ description }}</div>
    </ng-container>
  `,
  providers: [STRING_CONTROL_ACCESSOR],
  standalone: false,
})
export class FileGroupUploaderComponent extends FileControlValueAccessor<FileUploadInfo[]> {
  @Input() label: string;
  @Input() numFiles = 5;
  @Input() description: string;
  @Input() uploadUrl: string;
  @Input() customUploader: FileUploaderInterface;
  @Input() formGroup: UntypedFormGroup;
  @Input() formControlName: string;
  @Input() fileTypes: string[];
  @Input() disabled: boolean;
  @Input() enableDownload = true;
  @Output() fileUploaded = new EventEmitter<FileUploadInfo>();
  @Output() fileUploadError = new EventEmitter<Error>();
  @Output() fileRemoved = new EventEmitter<number>();

  constructor() {
    super();
    this.innerValue = [];
  }

  get canUpload(): boolean {
    return this.innerValue.length < this.numFiles;
  }

  onFileUploaded(value: FileUploadInfo): void {
    this.innerValue.push(value);
    this.formGroup.controls[this.formControlName].updateValueAndValidity();
    this.fileUploaded.emit(value);
  }

  clearValue(event: Event): void {
    this.value.splice(Number(event), 1);
    this.formGroup.controls[this.formControlName].updateValueAndValidity();
    this.fileRemoved.emit(Number(event));
  }

  handleError(err: Error): void {
    this.fileUploadError.emit(err);
  }
}
